'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var splToken = require('@solana/spl-token');

/** @group Programs */
const tokenProgram = {
  name: 'TokenProgram',
  address: splToken.TOKEN_PROGRAM_ID
};

/** @group Programs */
const associatedTokenProgram = {
  name: 'AssociatedTokenProgram',
  address: splToken.ASSOCIATED_TOKEN_PROGRAM_ID
};

exports.associatedTokenProgram = associatedTokenProgram;
exports.tokenProgram = tokenProgram;
//# sourceMappingURL=program.cjs.map
